import { MANAGEMENT_FEATURES, ManagementFeature } from '../../core-module/models/management-feature.model';

export function filterManagementFeatures(
  userRoles: string[],
  userPermissions: string[]
): ManagementFeature[] {
  return MANAGEMENT_FEATURES.filter(x =>
    (x.roles && userRoles.some((r: string) => x.roles!.includes(r))) ||
    (x.permissions && userPermissions.some((p: string) => x.permissions!.includes(p)))
  );
}
